<template>
  <CreateModal type="recharge" ref="createModal">
    <RechargeSelectType v-if="rechargeFields.type === null" />
    <RechargeByPix
      v-if="rechargeFields.type === 'ASAAS_PIX'"
      ref="rechargeAsaasPix"
    />
    <RechargeByCard
      v-if="rechargeFields.type === 'ASAAS_CREDIT_CARD'"
      ref="rechargeAsaasCreditCard"
    />
    <RechargeByBillet
      v-if="rechargeFields.type === 'ASAAS_BOLETO'"
      ref="rechargeAsaasBillet"
    />
  </CreateModal>
</template>

<script>
import CreateModal from '@/components/app/CreateModal'

import RechargeSelectType from '@/components/recharge/RechargeSelectType'
import RechargeByCard from '@/components/recharge/RechargeByCard'
import RechargeByBillet from '@/components/recharge/RechargeByBillet'
import RechargeByPix from './RechargeByPix.vue'

import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'RechargeCreate',

  components: {
    CreateModal,
    RechargeSelectType,
    RechargeByPix,
    RechargeByCard,
    RechargeByBillet,
  },

  data() {
    return {
      tab: 0,
    }
  },

  watch: {
    tab() {
      this.tab === 0
        ? this.setRechargeFields({ type: 'ASAAS_CREDIT_CARD' })
        : this.setRechargeFields({ type: 'ASAAS_BOLETO' })
    },
  },

  computed: {
    ...mapGetters(['rechargeFields']),
  },

  methods: {
    ...mapActions(['fetchCurrentRealEstate']),
    ...mapMutations(['setPixData', 'setSuccessData', 'setRechargeFields', 'resetRechargeFields']),
  },

  mounted() {
    this.$watch('$refs.createModal.dialog', (isOpen) => {
      if (isOpen) return

      Promise.resolve(this.rechargeFields)
        .then(({ type }) => {
          if (type === 'ASAAS_PIX') {
            const pixComp = this.$refs.createModal.$slots?.default[1]?.child
            pixComp?.clearRefreshInterval()
          }
        })
        .finally(() => {
          this.setPixData(null)
          this.setSuccessData(null)
          this.resetRechargeFields()
          this.fetchCurrentRealEstate()
        })
    })
  },
}
</script>
